import { useSharedAuth } from '@src/context/auth/useSharedAuth';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import { PostPermission } from '@src/features/shared/community/enums/postPermission';
import { useChannel } from '@src/hooks/useChannel';

export const useCanOpenThread = (): boolean => {
  const { profile } = useSharedAuth();
  const { channel } = useChannel();

  const isLoggedIn = profile?.tenantProfile?.isLogin || profile?.companyProfile?.isLogin;

  if (!isLoggedIn || !channel) {
    return false;
  }

  if (!profile.isTenant) {
    return channel.post_permission === PostPermission.ALL_MEMBERS;
  }

  if (profile.tenantProfile?.user?.role.code === TENANT_ROLE.MEMBER) {
    return false;
  }

  if (profile.tenantProfile?.user?.role.code === TENANT_ROLE.CONTENT) {
    return channel.post_permission === PostPermission.ALL_MEMBERS;
  }

  return true;
};
